import type { SimResult } from "@air-defence-sim/sim-core";
import { makeRenderer, type HighlightKind } from "./render.js";
import type { ThemeName } from "./theme.js";

export type ExportOptions = {
  result: SimResult;
  simT: number;
  scale: number;
  theme: ThemeName;
  highlight: HighlightKind;
  showTrails: boolean;
  logicalWidth: number;
  logicalHeight: number;
};

export async function exportPng(opts: ExportOptions): Promise<Blob> {
  const off = document.createElement("canvas");
  const renderer = makeRenderer(off);
  renderer.configure(opts.logicalWidth, opts.logicalHeight, opts.scale);
  renderer.setTheme(opts.theme);
  renderer.setShowTrails(opts.showTrails);
  renderer.setHighlight(opts.highlight);
  renderer.setResult(opts.result);
  renderer.drawFrame(opts.simT, 0);

  return await new Promise<Blob>((resolve, reject) => {
    off.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("toBlob failed"));
    }, "image/png");
  });
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
